export const new_notification = `subscription new_notification{
    new_notification{
        id
        time
        text
        text_en
        direction
        unread
    }
}`;
